import { useMediaQuery } from "@material-ui/core";
import BackIcon from "components/BackIcon";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

const NoCustomership = () => {
  const { t } = useTranslation();

  const matchesMediaQuery = useMediaQuery("(min-width: 600px)");

  const history = useHistory();

  return (
    <div
      style={{
        width: matchesMediaQuery ? "58%" : "100%",
        height: "fit-content",
        maxWidth: 750,
        textAlign: "center",
        padding: 16,
      }}
    >
      <h3 style={{ color: "#ffffff", marginTop: 0 }}>{t("login")}</h3>
      <p style={{ color: "#D3741C", fontSize: "1.125em", fontWeight: 400 }}>
        {t("no_customership")}
      </p>
      <p style={{ color: "#ffffff", fontSize: "1.125em", fontWeight: 400 }}>
        {t("only_for_forea_customers")}
        {t("please_be_contacted")}
      </p>
      <button
        onClick={() => {
          history.push("/login");
        }}
        style={{
          fontSize: "1.125em",
          background: "transparent",
          border: "none",
          textTransform: "uppercase",
          color: "#ffffff",
          cursor: "pointer",
          outline: "none",
          letterSpacing: "0.09375em",
          marginTop: 16,
        }}
      >
        <BackIcon />
        {t("back")}
      </button>
    </div>
  );
};

export default React.memo(NoCustomership);
